export default __webpack_public_path__ + "static/media/Rectangle 1045.ef1b3c83.png";